import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'UserConfirm',
  components: {
    Loading
  },
  data () {
    return {
      processing: false
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.user.categoryName,
      userIdentity: state => state.userForm.targetId,
      values: state => state.userForm.values,
      serviceModel: state => state.userForm.serviceModel,
      linkedCmsMstModel: state => state.userForm.linkedCmsMstModel
    }),
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      isRegister: 'userForm/isRegister',
      isModify: 'userForm/isModify',
      getValue: 'userForm/getValue'
    }),

    // list
    userTypeList () {
      //TODO
      return [
        {value: 2, label: '管理者'},
        {value: 4, label: 'サービス運用者'}
      ]
    },

    // result
    resultRoleKbn () {
      try {
        return Utility.getConstantsLabel(['UserRole'], this.values.inpRoleKbn)
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },
    resultService () {
      try {
        return this.serviceModel.filter(item => item.serviceUuid === this.values.inpService)[0].serviceName || Constants.BlankValue
      // eslint-disable-next-line
      } catch (e) {
        return Constants.BlankValue
      }
    },
    resultCms () {
      var list = []
      // console.log(this.values.inpCmsList)
      this.values.inpCmsList.forEach(id => {
        try {
          list.push(this.linkedCmsMstModel.filter(item => item.linkedCmsMstUuid === id)[0].linkedCmsName)
        // eslint-disable-next-line
        } catch (e) {
          console.log('no result')
        }
      })
      return list.length ? list.join('、') : Constants.BlankValue
    },
    resultStatus () {
      try {
        return Utility.getConstantsLabel(['Status'], this.values.inpStatus)
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // enable
    showSelectService () {
      return this.isAdmin && this.values.inpRoleKbn !== 1
    },
    showSelectCms () {
      return this.values.inpRoleKbn === 4
    },
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showToast: 'toast/show'
    }),
    turnBack () {
      this.$router.go(-1)
    },
    postData () {
      this.processing = true

      //
      let parameters = {
        request: {
          // name: this.values.inpName,
          email: this.values.inpEmail,
          roleKbn: this.values.inpRoleKbn
        }
      }
      if (this.isRegister) {
        parameters.request.name = this.values.inpName
      }
      if (this.values.inpRoleKbn !== 1 &&
        this.values.inpService) {
        parameters.request.serviceUuid = this.values.inpService
      }
      if (this.showSelectCms &&
        this.values.inpCmsList.length) {
        parameters.request.linkedCmsMstUuids = this.values.inpCmsList
      }
      if (this.isModify) {
        parameters.userUuid = this.userIdentity
        parameters.request.status = this.values.inpStatus
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['user'],
        [this.isRegister ?
          'v1UserPost' :
          'v1UserPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しいアカウントの登録' :
                'アカウント情報の変更',
              body: this.isRegister ?
                '「' + this.values.inpName + '」を登録しました。' :
                '「' + this.values.inpName + '」のアカウント情報を変更しました。',
            })

            // 一覧へリダイレクト
            this.$router.push({
              name: 'User'
            })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    }
  }
}
